<template>
  <popover-box :class="'builder-list-popover ' + className" ref="popover" :parent="parent" :direction="direction" :tipColor="tipColor">
    <div
      v-for="option in list"
      class="builder-list-popover__option"
      :class="optionClass(option)"
      :style="optionStyle"
      @click="(e) => selectOption(option.value, option, e)"
      :id="`popover-box-option-${option.name}`"
    >
      {{ option.name }}
    </div>
  </popover-box>

</template>

<script>

import PopoverBox from './PopoverBox'
import popoverContainerMixin from './popoverContainerMixin'

export default {
  components: {
    PopoverBox
  },
  mixins: [popoverContainerMixin],
  props: {
    list: {
      type: Array,
      required: true
    },
    currentValue: null,
    align: {
      type: String,
      default: 'left'
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    tipColor: String,
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    optionStyle () {
      return {
        'text-align': this.align
      }
    }
  },
  methods: {
    optionClass (op) {
      if (this.multiSelect) {
        return (this.currentValue
        ? (this.currentValue.filter(el => el === op.value).length > 0 ? 'is-selected' : '')
        : '')
      } else {
        return this.currentValue === op.value || this.currentValue === op.name ? 'is-selected' : ''
      }
    },
    selectOption (value, selectedOption, event) {
      this.$emit('select', value, selectedOption, event)
      if (this.dismiss && !this.multiSelect) {
        this.dismiss()
      }
    }
  }
}

</script>

<style lang="scss">

.builder-list-popover {

  &__option {
    width: 100%;
    min-width: 100px;
    padding-top: 6px;
    padding-bottom: 6px;
    cursor: pointer;
    text-align: center;

    &:hover {
      color: color(yellow);
    }

    &.is-selected {
      color: color(yellow);
    }
  }
}

</style>



// WEBPACK FOOTER //
// ListPopover.vue?4f38979d